export const NAVIGATE_TO_DEFAULT_MACHINE_KEY = 'navigateToDefaultMachine';
